import { fmtCurrency } from "../../helpers";

const Table = ({ details }) => {
  return (
    <>
      <table className="approved assigned">
        <thead>
          <tr>
            <th colSpan="4" className="hdg">
              {`${details.level.name} - ID ${details.id}`}
            </th>
          </tr>
          <tr>
            <td style={{ width: "33%" }}>Name</td>
            <td style={{ width: "34%" }}>Organization</td>
            <td style={{ width: "33%" }}>Email</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="center">{details.name}</td>
            <td className="center">{details.organization}</td>
            <td className="center">
              <a href={`mailto:${details.email}`}>{details.email}</a>
            </td>
          </tr>
        </tbody>
      </table>

      <table className="approved assigned">
        <thead>
          <tr>
            <th colSpan="4" className="hdg">
              Accepted Guest Summary
            </th>
          </tr>
          <tr>
            <td className="center" style={{ width: "25%" }}>
              Golf
            </td>
            <td className="center" style={{ width: "25%" }}>
              Sporting Clays
            </td>
            <td className="center" style={{ width: "25%" }}>
              Welcome Party
            </td>
            <td className="center" style={{ width: "25%" }}>
              Gift Package
            </td>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td className="center">{details.summary.golf}</td>
            <td className="center">{details.summary.sporting}</td>
            <td className="center">{details.summary.welcome}</td>
            <td className="center">{details.summary.gift}</td>
          </tr>
        </tbody>
      </table>

      <table
        className="approved"
        style={{ marginTop: "25px", marginBottom: "5px" }}
      >
        <thead>
          <tr>
            <th className="left" style={{ width: "75%" }}>
              Item Description
            </th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {details.items.map((item) => {
            return (
              <tr key={item.id}>
                <td className="left">{item.name}</td>
                <td className="right">{fmtCurrency(item.amt / 100)}</td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <th
              className="right"
              style={{ padding: "10px", fontSize: "1.15rem" }}
            >
              TOTAL
            </th>
            <th
              className="right"
              style={{
                padding: "12.5px 7.5px 12.5px 10px",
                fontSize: "1.15rem",
              }}
            >
              {details.totals.total}
            </th>
          </tr>
          <tr>
            <td className="right" style={{ paddingRight: "10px" }}>
              Payments Received
            </td>
            <td className="right">({details.totals.paid})</td>
          </tr>
          <tr>
            <td className="right" style={{ paddingRight: "10px" }}>
              Amount Due
            </td>
            <td className="right">{details.totals.due}</td>
          </tr>
        </tfoot>
      </table>
    </>
  );
};

export default Table;
